import { textStyles } from 'theme/textStyles'

// #DESIGN_2023
export const Heading = {
  sizes: textStyles,
}
